// extracted by mini-css-extract-plugin
module.exports = {"notifications":"Notifications_notifications__ueM57","list":"Notifications_list__1OJzU"};